import { Text, View, StyleSheet } from "@react-pdf/renderer";
import {
  formatNumberAnglo as formatNumber,
  toNumber,
  getIncrementosDeduccionesCalculados,
} from "../../../services/mappings";

const styles = StyleSheet.create({
  table: { marginTop: 6, fontSize: 8, border: "1pt solid #000" },
  row: { flexDirection: "row" },
  headerRow: { fontSize: 9, fontWeight: "bold", backgroundColor: "#d0d0d0" },
  cell: {
    borderRight: "0.5px solid #000",
    borderBottom: "0.5px solid #000",
    paddingVertical: 2,
    paddingHorizontal: 3,
    justifyContent: "center",
  },
  hCell: {
    paddingVertical: 4,
  },
  wDesc: { width: "46%" },
  wAma: { width: "15%" },
  wPa: { width: "26%" },
  wTa: { width: "13%" },
  center: { textAlign: "center" },
  right: { textAlign: "right" },
  bold: { fontWeight: "bold" },
  bg: { backgroundColor: "#f0f0f0" },
});

function IncrementsTable({ incrementos, detalles }) {
  const data = incrementos?.data ?? [];
  const {
    incRows,
    dedRows,
    incAma,
    incPa,
    incTa,
    dedAma,
    dedPa,
    dedTa,
    subAma,
    subPa,
    subTa,
  } = getIncrementosDeduccionesCalculados(detalles, incrementos);
  // Estructura de secciones:
  // tipo 2 => Incrementos
  // tipo 1 => Deducciones

  // Regla clave por iD_T:
  // - "1-" => Acumulado mes anterior
  // - "2-" => Período actual
  // - Total acumulado = ama + pa
  const mapRow = (r) => {
    const idt = String(r?.iD_T ?? "").trim();
    const monto = toNumber(r?.monto);

    const ama = idt.startsWith("1-") ? monto : 0;
    const pa = idt.startsWith("2-") ? monto : 0;
    const ta = ama + pa;

    return {
      nombre: r?.nombre ?? "",
      ama,
      pa,
      ta,
    };
  };

  const sum = (arr, key) => arr.reduce((acc, x) => acc + toNumber(x[key]), 0);

  const renderDataRow = (label, ama, pa, ta, bold = false, total = false) => (
    <View
      style={[styles.row, bold ? styles.bg : undefined]}
      key={`${label}-${ama}-${pa}-${ta}`}
      wrap={false}
    >
      <View
        style={[styles.cell, styles.wDesc, total ? styles.hCell : undefined]}
      >
        <Text style={bold ? styles.bold : undefined}>{label}</Text>
      </View>
      <View
        style={[styles.cell, styles.wAma, total ? styles.hCell : undefined]}
      >
        <Text style={[styles.right, bold ? styles.bold : undefined]}>
          {formatNumber(ama, 2, 2)}
        </Text>
      </View>
      <View style={[styles.cell, styles.wPa, total ? styles.hCell : undefined]}>
        <Text style={[styles.right, bold ? styles.bold : undefined]}>
          {formatNumber(pa, 2, 2)}
        </Text>
      </View>
      <View style={[styles.cell, styles.wTa, total ? styles.hCell : undefined]}>
        <Text style={[styles.right, bold ? styles.bold : undefined]}>
          {formatNumber(ta, 2, 2)}
        </Text>
      </View>
    </View>
  );

  return (
    <View style={styles.table} wrap={false}>
      <View style={[styles.row, styles.headerRow]}>
        <View style={[styles.cell, styles.wDesc, styles.hCell]}>
          <Text style={styles.bold}>Incrementos y Deducciones</Text>
        </View>
        <View style={[styles.cell, styles.wAma, styles.hCell]}>
          <Text style={[styles.center, styles.bold]}>
            Acumulado mes anterior
          </Text>
        </View>
        <View style={[styles.cell, styles.wPa, styles.hCell]}>
          <Text style={[styles.center, styles.bold]}>Período actual</Text>
        </View>
        <View style={[styles.cell, styles.wTa, styles.hCell]}>
          <Text style={[styles.center, styles.bold]}>Total acumulado</Text>
        </View>
      </View>

      {renderDataRow("Incrementos", incAma, incPa, incTa, true)}
      {incRows.map((r) => renderDataRow(r.nombre, r.ama, r.pa, r.ta, false))}

      {renderDataRow("Deducciones", dedAma, dedPa, dedTa, true)}
      {dedRows.map((r) => renderDataRow(r.nombre, r.ama, r.pa, r.ta, false))}

      {renderDataRow(
        "SUBTOTAL INCREMENTOS Y DEDUCCIONES",
        subAma,
        subPa,
        subTa,
        true,
        true,
      )}
    </View>
  );
}

export default IncrementsTable;
